<template>
    <div>
        <div>
            <form name="reqKMCISForm" method="post" action="#">
                <input type="hidden" name="tr_cert" v-model="tr_cert">
                <input type="hidden" name="tr_url"  v-model="tr_url">
                <input type="hidden" name="tr_add" v-model="tr_add">
            </form>
        </div>
        <v-dialog/>
    </div>
</template>

<script>
import { getKmcDetailEncrypt } from '@/api/common'
export default {
    name: "CallKmcAuthPop",
    data() {
        return {
            tr_cert: '',
            tr_url: '',//TODO 나중에 tr_url 변경
            tr_add: 'N',
            currentURL: '',
            reqInfo: '',
            returnURL: '',

        }
    },
    created() {
        this.getInfo();
    },
    methods: {
        /** 
         * Function    : getInfo
         * Description : KMC 정보
         **/
        getInfo() {
            let serverName = location.hostname
            this.tr_add = this.$route.query.tr_add
            getKmcDetailEncrypt({serverName: serverName}).then(res => {
                this.tr_cert = res.data.tr_cert
                this.tr_url = res.data.tr_url
                this.$nextTick(() => {
                    document.reqKMCISForm.action = 'https://www.kmcert.com/kmcis/web/kmcisReq.jsp';
                    document.reqKMCISForm.submit();
                })
            }).catch(error => {
                alert(error.message)
            })
        },
    },
}
</script>

<style scoped>

</style>